import React from 'react';
import { displayToken } from '../lib/model';

/** A token in mono, with its leading space shown as a faint dot. */
export function TokenText({
  text,
  className
}: {
  text: string;
  className?: string;
}) {
  const {
    space,
    body,
    punctuation
  } = displayToken(text);
  return <span className={`font-mono ${className ?? ''}`} data-id="element-305" data-mp="2ap8wfkqot0ca">
      {space && <span className="opacity-40" data-id="element-306" data-mp="2aps2a332by9y">·</span>}
      {punctuation && <span className="opacity-40" data-id="element-307" data-mp="1mz4tlflbp4mc">“</span>}
      {body}
      {punctuation && <span className="opacity-40" data-id="element-308" data-mp="1i0l63ar2zkrv">”</span>}
    </span>;
}